
import { Options, prop, Vue } from "vue-class-component";
import CardSelectorV2 from "./card-selector-v2.vue";
import Checkbox from "primevue/checkbox";
import Select from "@/app/ui/components/check-box/index.vue";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import debounce from "lodash/debounce";
import { LocationController } from "@/app/ui/controllers/LocationController";
import UploadFile from "@/app/ui/components/upload-file/index.vue";
import ToggleV2 from "@/app/ui/components/toggle-v2/index.vue";
import { ConfigBucketStorage } from "@/feature-flags/flags-config-bucket-storage";
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";
import DiscountProduct from "./discount-product.vue"
import { ListRatesApiRequest } from "@/data/payload/api/BaseRatesApiRequest";
import DateTimeInputField from "@/app/ui/components/date-time-input/field.vue";
import ClientDiscountConfigToggle from "./client-discount-config-toggle.vue";

class Props {
  modelValue = prop<any>({
    required: true,
  });
  error = prop<any>({
    required: true,
  });
  customPriceOption = prop<any[]>({
    default: () => [],
  });
  customPriceOptionEdit = prop<any[]>({
    default: () => [],
  });
  validateStartEndDate = prop<any>({
    required: false,
    default: false,
  });
  isEdit = prop<any>({
    required: false,
  });
}
@Options({
  emits: ["change", "update:modelValue", "update:error"],
  components: {
    CardSelectorV2,
    Checkbox,
    UploadFile,
    ToggleV2,
    DiscountProduct,
    DateTimeInputField,
    ClientDiscountConfigToggle
  },
})
class PriceTypeForm extends Vue.with(Props) {
  created() {
    this.fetchVersionRates("");
  }

  mounted() {
    if (this.isEdit && !this.modelValue.originCities?.length) {
      this.modelValue.originCities = [{ name: this.$t("clientManagement.priceTypeForm.all3lc").toString(), value: "All" }];
    }
  }

  toggleBasedDistrict() {
    this.modelValue.retailBasedDistrict = !this.modelValue.retailBasedDistrict;
    this.$emit("update:modelValue", {
      ...this.modelValue,
      retailBasedDistrict: this.modelValue.retailBasedDistrict,
    });
  }

  onSelect(value: any) {
    this.$emit("update:modelValue", {
      ...this.modelValue,
      isCustomRate: value,
    });
  }

  onResetForm() {
    this.modelValue.versionName = "";
    this.modelValue.versionBasic = "";
    this.modelValue.discount = "";
    this.modelValue.priceRateStartDate = new Date(
      this.$moment().add(1, "hour").toDate()
    );
    this.modelValue.priceRateExpired = new Date(
      this.$moment()
        .add(1, "days")
        .toDate()
    );
    this.modelValue.priceRateEndDate = new Date(
      this.$moment()
        .add(1, "days")
        .toDate()
    );
    this.modelValue.archiveFile = "";
    this.modelValue.retailBasedDistrict = false;
    this.modelValue.isInsurance = false;
    this.modelValue.customRates = 2;
    this.modelValue.insurance = "";
    this.modelValue.originCities = [{ name: this.$t("clientManagement.priceTypeForm.all3lc").toString(), value: "All" }];
    this.$emit("update:modelValue", {
      ...this.modelValue,
      versionBasic: "",
      isCustomRate: "kombinasi",
      discount: "",
      priceRateStartDate: new Date(
        this.$moment().add(1, "hour").toDate()
      ),
      priceRateExpired: new Date(
        this.$moment()
          .add(1, "days")
          .toDate()
      ),
      priceRateEndDate: new Date(
        this.$moment()
          .add(1, "days")
          .toDate()
      ),
      versionName: "",
      archiveFile: "",
      isInsurance: false,
      customRates: 2,
      insurance: "",
      originCities: [{ name: this.$t("clientManagement.priceTypeForm.all3lc").toString(), value: "All" }],
      retailBasedDistrict: false,
    });
  }

  isOpenSelectInsurance = false;

  insurances = [
    {
      name: "Select insurance type",
      value: "",
    },
    {
      name: "Custom Rates",
      value: "custom-rates",
    },
    {
      name: "Bundling (No Insurance Fee)",
      value: "bundling (No Insurance Fee)",
    },
  ];
  onOpenSelectInsurance() {
    this.isOpenSelectInsurance = true;
  }
  onCloseSelectInsurance() {
    this.isOpenSelectInsurance = false;
  }
  async onSelectInsurance(_: string, value: string) {
    if (!value) this.modelValue.isInsurance = false;
    this.onCloseSelectInsurance();
    this.modelValue.insurance = value;
    this.modelValue.customRates = 2;
    await this.$emit("update:modelValue", {
      ...this.modelValue,
      insurance: value,
      customRates: 2,
    });
    this.error.customRates = false;
    await this.$emit("update:error", { ...this.error, customRates: false });
  }

  errorCaptionCustomRates = "";
  validateCustomRates(value: string) {
    value = `0,${value}`.replace(/,/g, ".");
    if (Number(value) < 0.2) {
      this.error.customRates = true;
      this.errorCaptionCustomRates = this.$t("clientManagement.priceTypeForm.customRatesMin").toString();
      this.$emit("update:error", { ...this.error, customRates: true });
      return;
    } else if (Number(value) > 0.99) {
      this.error.customRates = true;
      this.errorCaptionCustomRates = this.$t("clientManagement.priceTypeForm.customRatesMax").toString();
      this.$emit("update:error", { ...this.error, customRates: true });
      return;
    } else {
      this.error.customRates = false;
      this.$emit("update:error", { ...this.error, customRates: false });
      return;
    }
  }

  templateFile = "Download.csv";
  templateFileName = "template-client-custom-rate.xlsx";
  templateFileLink = `${ConfigBucketStorage.config_bucket_dev_genesis_announcement.getValue()}/template-bulk-booking-commission.xlsx`;
  // download file
  download(url: string, fileName: string) {
    const newFileName = fileName
      .split(".")
      .slice(0, -1)
      .join(".");
    downloadFile(url, newFileName, ".xlsx");
  }

  // version rates
  fetchVersionRates = debounce((search: string) => {
    ClientRegistrationController.getVersionRateList(
      new ListRatesApiRequest({
        search,
        limit: search
          ? 0
          : FlagsPermissionClient.config_rate_listing_row_limit.getValue()
      })
    );
  }, 250);

  get versionRates() {
    return ClientRegistrationController.versionRateList;
  }

  get loadingVersionRates() {
    return ClientRegistrationController.loadingVersionRateList;
  }

  formatFloat(value: string) {
    return value
      .replace(/[^0-9,.]+/g, "")
      .replace(/\.|\.,|,,|,\./g, ",")
      .replace(/,(\d+),/g, ",$1");
  }

  validateDiscount(value: string) {
    value = value.replace(/,/g, ".");
    if (Number(value) < 0 || Number(value) > 30) {
      this.error.discount = true;
      this.$emit("update:error", { ...this.error, discount: true });
    } else {
      this.error.discount = false;
      this.$emit("update:error", { ...this.error, discount: false });
    }
  }

  // origin city
  fetchCity(search: string) {
    LocationController.getCityList({
      search: search,
      status: "active",
      page: 1,
      limit: 500,
      newEndpoint: true
    });
  }
  filterCity = debounce((search: string) => {
    if (search.length > 2 || !search) this.fetchCity(search);
  }, 250);
  get cityExcludeOptions() {
    return LocationController.cityData.cityData.map((e) => ({
      id: e.id,
      name: `${e.code} - ${e.name}`,
      value: `${e.code}`,
    }));
  }
  get cityOptions() {
    return [
      {
        name: this.$t("clientManagement.priceTypeForm.all3lc").toString(),
        value: "All",
      },
      ...this.cityExcludeOptions,
    ];
  }
  get isLoadingCity() {
    return LocationController.isLoading;
  }

  // Error exist
  get isExist() {
    return ClientRegistrationController.isExist;
  }

  setIsExist(val: boolean) {
    ClientRegistrationController.setIsExist(val);
  }

  get columnToValidate() {
    return [
      {
        column: "origin_city_code",
        type: "string",
      },
      {
        column: "destination_city_code",
        type: "string",
      },
      {
        column: "service_type",
        type: "string",
      },
      {
        column: "product_name",
        type: "string",
      },
      {
        column: "start_weight",
        type: "number",
      },
      {
        column: "end_weight",
        type: "string",
      },
      {
        column: "publish_rate",
        type: "number",
      },
      {
        column: "shipping_surcharge",
        type: "number",
      },
      {
        column: "document_surcharge",
        type: "number",
      },
    ];
  }
  get tomorrow() {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  get isPeriodDateTimeEnabled() {
    return FlagsPermissionClient.permission_period_date_time.isEnabled();
  }

  onUpdateClientDiscountConfigToggle(value: boolean) {
    if (value) return;

    this.modelValue.discount = "";
  }
}

export default PriceTypeForm;
